<i18n>
  {
    "fr": {
      "title": "Bagages",
      "placeholder": "Bagages en soute",
      "with-luggage": "Avec bagages",
      "without-luggage": "Sans bagages",
      "indifferent": "Indifférent"
    },
    "en": {
      "title": "Luggage",
      "placeholder": "Checked luggage",
      "with-luggage": "With luggage",
      "without-luggage": "Without luggage",
      "indifferent": "Indifferent"
    }
  }
</i18n>

<template>
  <v-menu
    v-if="false"
    v-model="menu"
    :close-on-content-click="false"
    min-width="360px"
  >
    <template #activator="{on, attrs, value}">
      <v-btn
        v-bind="attrs"
        depressed
        :color="isDefaultValue ? 'white' : 'primaryLight'"
        :class="{'filter-not-default-state': !isDefaultValue}"
        class="pr-2"
        v-on="on"
      >
        {{ $t('title') }}
        <v-icon
          v-if="value === true"
          color="primary"
        >
          mdi-menu-up
        </v-icon>
        <v-icon
          v-else-if="value === false"
          color="primary"
        >
          mdi-menu-down
        </v-icon>
      </v-btn>
    </template>

    <v-card
      flat
    >
      <v-card-title
        class="py-0"
      >
        <v-col>
          {{ $t('title') }}
        </v-col>
        <v-spacer />
        <v-btn
          icon
          @click="menu = false"
        >
          <v-icon color="primary">
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-radio-group
          v-model="selectedOption"
          data-cy="luggage-select"
          solo
          flat
          :menu-props="{'offset-y': true}"
          :items="luggageOptions"
          item-text="optionName"
          item-value="value"
          :placeholder="$i18n.t('placeholder')"
        >
          <v-radio
            v-for="option in luggageOptions"
            :key="option.value"
            :label="option.optionName"
            :value="option.value"
          />
        </v-radio-group>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'FlightSelectLuggage',
  data: () => ({
    menu: false
  }),
  computed: {
    ...mapState({
      luggageOptionsState: state => state.fb.searchParameters.luggageOptions,
      selectedLuggageOptionState: state => state.fb.searchParameters.selectedLuggageOption
    }),
    /**
     * A mapping is done on the array to add an attribute to the object (text format)
     * @return {(({name: string, value: string} & {optionName: VueI18n.TranslateResult}) | ({name: string, value: string} & {optionName: VueI18n.TranslateResult}) | ({name: string, value: *} & {optionName: VueI18n.TranslateResult}))[]}
     */
    luggageOptions () {
      return this.luggageOptionsState.map(entry => {
        const optionName = this.$i18n.t(entry.name)
        return Object.assign({}, entry, { optionName })
      })
    },
    selectedOption: {
      /**
       * Return vueX store state
       * @return {string}
       */
      get () {
        return this.selectedLuggageOptionState
      },
      /**
       * Set new Value to vueX store state
       * @param newValue
       */
      set (newValue) {
        this.changeSelectedLuggageOption(newValue)
      }
    },
    /**
     * Verify if component is at default state
     * @return {boolean}
     */
    isDefaultValue () {
      return this.selectedOption === 'no'
    }
  },
  methods: {
    ...mapMutations({
      changeSelectedLuggageOption: 'fb/searchParameters/changeSelectedLuggageOption'
    })
  }
}
</script>

<style scoped>
  .filter-not-default-state {
    color: #003d58;
  }
</style>
